import { textInput } from 'constants/fonts';

export default {
  formTitle: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '20px 30px 10px'
  },
  form: {
    width: '95%',
    padding: '0px 30px 10px',
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box'
  },
  field: {
    height: 85,
    display: 'flex',
    alignItems: 'center'
  },
  textInputSize: {
    fontSize: textInput
  }
};
